import { Body, Controller, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { GlobalResponseObject, LoginResponse } from '@schemax-whatsapp/shared-models';
import { LoginRequest } from './model/login.request';
import { UserService } from './user.service';

@Controller('user')
export class UserController {
  constructor(
    private applicationExceptionHandler: ApplicationExceptionHandler,
    private userService: UserService,
  ) { }


  @Post('/authorizeUser')
  async authorizeUser(@Body() req: LoginRequest): Promise<LoginResponse> {
    try {
      return await this.userService.authorizeUser(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(LoginResponse, err);
    }
  }


  @Post('/changeExistingPassword')
  async changeExistingPassword(@Body() req: LoginRequest): Promise<GlobalResponseObject> {
    try {
      return await this.userService.changeExistingPassword(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(GlobalResponseObject, err);
    }
  }
}
